import { cn } from '@/lib/utils'

export function Tile({
  label,
  value,
  tone,
  detail,
  testId,
}: {
  label: string
  value: string
  tone?: 'up' | 'down'
  detail?: string
  testId: string
}) {
  return (
    <div className="jn-metric" title={detail}>
      <div className="text-[9px] font-bold tracking-[0.16em] text-muted-foreground">{label}</div>
      <div
        className={cn(
          'num mt-1 text-xl font-bold',
          tone === 'up' ? 'text-success' : tone === 'down' ? 'text-destructive' : 'text-foreground',
        )}
        data-testid={testId}
      >
        {value}
      </div>
    </div>
  )
}
